import Api from '@/repository/api';
import { ICategoryRepository } from '@/repository/category/CategoryRepository.types';
import { CategoryResponseType, ICategory } from '@/entity/category/category.types';
//import { Category } from '@/entity/category/category';
import Cms_Category from '@/entity/staff/staff'
import {Cms_CategoryResponseType, ICms_Category} from '@/entity/staff/staff.types'

export default class CategoryRepository implements ICategoryRepository {
    async fetchAll(): Promise<ICms_Category[]> {
        const response = await Api.get('/staff/csm_category/get');
        const respData = response.data as Cms_CategoryResponseType[];
        return respData.map((role: Cms_CategoryResponseType) => new Cms_Category(role));
    }
}
